import { render, staticRenderFns } from "./TripListSpeed.vue?vue&type=template&id=23b14610&scoped=true&"
import script from "./TripListSpeed.vue?vue&type=script&lang=js&"
export * from "./TripListSpeed.vue?vue&type=script&lang=js&"
import style0 from "./TripListSpeed.vue?vue&type=style&index=0&id=23b14610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b14610",
  null
  
)

export default component.exports